"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PluralTrans = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _i18n = require("./i18n");

var PluralTrans = function PluralTrans(_ref) {
  var t = _ref.t,
      count = _ref.count,
      defaultValues = _ref.defaultValues;

  var pluralizationSuffix = _i18n.i18n.services.pluralResolver.getSuffix(_i18n.i18n.language, count).slice(1);

  var components = defaultValues[pluralizationSuffix];

  if (!components) {
    components = defaultValues.base;
  } // we want to always keep key the same. only add a suffix


  return /*#__PURE__*/_react.default.createElement(_i18n.Trans, {
    t: t,
    count: count,
    components: components
  }, defaultValues.base);
};

exports.PluralTrans = PluralTrans;
PluralTrans.propTypes = {
  t: _propTypes.default.func.isRequired,
  defaultValues: _propTypes.default.shape({
    base: _propTypes.default.element.isRequired,
    plural: _propTypes.default.element.isRequired
  }).isRequired,
  count: _propTypes.default.number.isRequired
};